const assertFiniteNumber = (value: number, name: string): void => {
  if (!Number.isFinite(value)) {
    throw new TypeError(`${name} 必须是有限数字`)
  }
}

const assertFen = (value: number): void => {
  assertFiniteNumber(value, '金额')
  if (!Number.isInteger(value)) {
    throw new TypeError('金额必须是整数，单位为分')
  }
}

export const formatMoney = (amountInFen: number): string => {
  assertFen(amountInFen)
  return (amountInFen / 100).toFixed(2)
}

export const fenToYuan = formatMoney

export const yuanToFen = (amountInYuan: string | number): number => {
  const normalized = typeof amountInYuan === 'number' ? String(amountInYuan) : amountInYuan.trim()
  if (!/^-?\d+(?:\.\d{1,2})?$/.test(normalized)) {
    throw new TypeError('元金额最多保留两位小数')
  }
  const negative = normalized.startsWith('-')
  const unsigned = negative ? normalized.slice(1) : normalized
  const [integerPart = '0', decimalPart = ''] = unsigned.split('.')
  const fen = Number(integerPart) * 100 + Number(decimalPart.padEnd(2, '0'))
  return negative ? -fen : fen
}

export const addMoney = (...values: number[]): number => {
  values.forEach(assertFen)
  return values.reduce((total, value) => total + value, 0)
}

export const subtractMoney = (minuend: number, subtrahend: number): number => {
  assertFen(minuend)
  assertFen(subtrahend)
  return minuend - subtrahend
}

export const multiplyMoney = (amountInFen: number, quantity: number): number => {
  assertFen(amountInFen)
  assertFiniteNumber(quantity, '数量')
  if (!Number.isInteger(quantity) || quantity < 0) {
    throw new TypeError('数量必须是非负整数')
  }
  return amountInFen * quantity
}

export const calculateDiscount = (originalAmount: number, payableAmount: number): number => {
  assertFen(originalAmount)
  assertFen(payableAmount)
  return Math.max(0, originalAmount - payableAmount)
}
